import Cookies from 'js-cookie'

export const getStore = (name) => Cookies.get(name)

export const store = (name, value, attributes) =>
  Cookies.set(name, value, attributes)
